import { useCallback, useEffect, useState } from "react";
import {
  fetchInstrumentEvents,
  type InstrumentEvent,
  type InstrumentEventsResponse,
} from "features/market/api/InstrumentEvents";

interface UseInstrumentEventsReturn {
  events: InstrumentEvent[];
  loading: boolean;
  error: string | null;
  updatedAt?: string;
  refresh: () => Promise<void>;
}

export function useInstrumentEvents(enabled = true): UseInstrumentEventsReturn {
  const [data, setData] = useState<InstrumentEventsResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    try {
      const response = await fetchInstrumentEvents();
      setData(response);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    events: data?.events ?? [],
    loading,
    error,
    updatedAt: data?.updatedAt,
    refresh,
  };
}

